import React from 'react';
import { IconProps } from './types';

const Share2: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181b32',
  ignoreColor,
}) => (
  <svg
    width={1.18 * size}
    height={size}
    viewBox="0 0 26 22"
    className={className}
  >
    <path
      d="M24.26 9.12h0L13.35.26h0A.52.52 0 0012.8.2h0a.46.46 0 00-.24.45v4.73a12.55 12.55 0 00-8.85 3.1C1.01 11.03-.14 14.9.21 19.97a.49.49 0 00.51.48.58.58 0 00.47-.29h0a14 14 0 012.85-3.68 10.47 10.47 0 018.47-2.93v4.83a.5.5 0 00.29.46h0a.55.55 0 00.55-.06l10.91-8.87h0a.49.49 0 00.19-.39.53.53 0 00-.19-.4zM13.54 17.3v-4.2a.51.51 0 00-.44-.5c-6.36-1-10.28 3.28-11.92 5.62 0-4 1.08-7 3.19-9a11.59 11.59 0 017.84-2.82h.76a.59.59 0 00.39-.02.53.53 0 00.18-.38V1.73l9.58 7.79z"
      fill={!ignoreColor ? color : undefined}
      stroke={!ignoreColor ? color : undefined}
      strokeWidth={0.3}
    />
  </svg>
);

export default Share2;
